import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '~/shared/utils/translation';

const StyledCard = styled.div(({ theme }) => ({
    width: '100%',
    listStyle: 'none',
    borderBottom: `1px solid ${theme.colors.brownLight}`,
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: `${theme.space[4]}`,
    lineHeight: theme.space[7],
    ...theme.mixins.useTextStyle('bodySmall'),
}));

export const StyledDd = styled.dd(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.space[1]} 0 ${theme.space[1]} 0`,
    textTransform: 'capitalize',
}));

export const StyledInfo = styled.div(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.colors.brownLight}`,
    padding: `${theme.space[4]} 0 ${theme.space[4]} 0`,
}));

const StyledEmail = styled.div(({ theme }) => ({
    color: theme.colors.black,
    display: 'flex',
    ':has(:focus-visible)': {
        boxShadow: theme.shadows.accessibility,
    },
    a: {
        textDecoration: 'underline',
        color: theme.colors.black,
    },
    span: {
        textDecoration: 'none',
        marginRight: theme.space[2],
    },
}));

export type StoreTime = { day: string; opens: string; closes: string };

type Props = {
    storeInfo?: any;
};
export const CardStore = (props: Props) => {
    const { storeInfo } = props;
    const { translate } = useTranslation();
    return (
        <StyledCard>
            <StyledInfo>
                {Array.isArray(storeInfo.c_openingHours) &&
                    storeInfo.c_openingHours.map((storeOption: StoreTime | undefined | null) => {
                        return (
                            <StyledDd>
                                <dl>{storeOption?.day}</dl>
                                <dl>
                                    {storeOption?.opens ? (
                                        <>
                                            {storeOption?.opens} - {storeOption?.closes}
                                        </>
                                    ) : (
                                        <>{translate('pdp.closedStore')}</>
                                    )}
                                </dl>
                            </StyledDd>
                        );
                    })}
            </StyledInfo>
            <StyledInfo>
                <StyledEmail>
                    <span>@</span>
                    <a href={`mailto:${storeInfo.email}`}>{storeInfo.email}</a>
                </StyledEmail>
                <StyledEmail>
                    {translate('findStore.phoneStore')}:
                    <a href={`tel:${storeInfo.phone}`}>{storeInfo.phone}</a>
                </StyledEmail>
            </StyledInfo>
            {storeInfo?.c_storeDescription && (
                <StyledInfo>{storeInfo?.c_storeDescription}</StyledInfo>
            )}
        </StyledCard>
    );
};
